module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kansai-3-891bbaca875fdb0e3f38b67cbff03167.jpg";